
import {
  defineComponent, ref, watch,
} from 'vue';

import {
  Image,
} from 'ant-design-vue';

import {
  ticketImageIp,
} from '@/configs/index';

export default defineComponent({
  components: {
    Image,
  },
  props: {
    curTableRow: {
      type: Object,
      default: () => ({}),
      require: true,
    },
  },
  setup (props, { emit, }) {
    const fileLists = ref<any[]>([]);
    const textFileLists = ref<any[]>([]);
    const textFileNameLists = ref<any[]>([]);
    const selectedRowsObj = ref<any>({});

    const streetTiltle = (val: any) => `选中${val.length}人`;

    const backToList = () => {
      emit('backToList');
    };

    const openFile = (urlStr: string) => {
      window.open(urlStr);
    };

    watch(() => props.curTableRow, (cur, old) => {
      cur.userName.split(';').forEach((item: any) => {
        const [key, value,] = item.split(':');

        selectedRowsObj.value[key] = value.split(',');
        if (cur.picPath) {
          fileLists.value = cur.picPath.split(',').map((i: any) => `${ticketImageIp}${i}`);
        }
        if (cur.annexName) {
          textFileNameLists.value = cur.annexName.split(',');
          textFileLists.value = cur.annexPath?.split(',').map((i: any) => `${ticketImageIp}${i}`);
        }
      });
    });

    return {
      fileLists,
      textFileLists,
      textFileNameLists,
      selectedRowsObj,
      openFile,
      streetTiltle,
      backToList,
    };
  },
});
